import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import App from './App.jsx';
import trTR from '@shopify/polaris/locales/tr.json';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppProvider i18n={trTR}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>
);
